import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { map } from "rxjs/operators";
import { AppSettings } from "../../../config/config";
import { apiConstants } from "../../constant/apiConstant";

export interface StaffAttendanceRecord {
  userId: string;
  name: string;
  employmentId: string;
  inTime: string | null;
  outTime: string | null;
}

export interface GetStaffAttendanceResponse {
  status: boolean;
  message?: string;
  body?: {
    staffAttendanceData: StaffAttendanceRecord[];
    maxPageNumber: number;
  };
}

export interface GetStaffAttendanceParams {
  staffId: number | string;
  attendanceDate: string;
  searchedStaffName: string;
  pageNumber: number;
  pageLimit: number;
}

@Injectable({ providedIn: 'root' })
export class StaffViewAttendanceService {
  private url = AppSettings.API_ENDPOINT_STAFF;

  constructor(private http: HttpClient) {}

  getStaffAttendanceInfo(params: GetStaffAttendanceParams) {
    const httpParams = new HttpParams()
      .set('lang', 'en')
      .set('staffId', String(params.staffId))
      .set('attendanceDate', params.attendanceDate)
      .set('searchedStaffName', params.searchedStaffName)
      .set('pageNumber', String(params.pageNumber))
      .set('pageLimit', String(params.pageLimit));
    return this.http
      .get<GetStaffAttendanceResponse>(this.url + apiConstants.getStaffAttendance, { params: httpParams })
      .pipe(map((res) => res));
  }
}
